import React from 'react';
import cx from 'classnames';
import styles from './MicastTile.module.scss';
import { Api } from '@carbon/pictograms-react';
import { Tile } from '@carbon/react';
import PropTypes from 'prop-types';

class MicastTile extends React.Component {
  render() {
    const { id, label, onClick } = this.props;
    return (
      <Tile
        light={true}
        className={cx(styles.micastTileStyle)}
        key={`micast_tile_id:${id}`}
        onClick={() => {
          onClick(id);
        }}>
        <Api className={cx(styles.micastTilePictogramStyle)} />
        <div className={cx(styles.micastTileTextStyle)}>{label}</div>
      </Tile>
    );
  }
}

MicastTile.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

MicastTile.defaultProps = {
  onClick: (_id) => {},
};

export default MicastTile;
